import OperationsPlanner from "../../components/Operations/Planner/OperationsPlanner";

const OperationsPlannerPage = () => {
  return <OperationsPlanner />;
};

export default OperationsPlannerPage;
